import { useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import FlxGrid from "../../../_src_shared/components/layout/FlxGrid";
import InfoGridItem from "./InfoGridItem";

const InfoGrid = ({
  items,
  width = "350px",
  gap = "24px 22px",
  mb = 4,
  sx = {},
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <FlxGrid
      // suppressAutoMobile
      width={isMobile ? "100px" : width}
      sx={{
        gap,
        mb,
        ...sx,
      }}
    >
      {items.map((item, index) => (
        <InfoGridItem
          key={index}
          label={item.label}
          value={item.value}
          fullWidth={item.fullWidth}
        />
      ))}
    </FlxGrid>
  );
};
export default InfoGrid;
